/**
 * Add addon quantity, max value = initial quantity;
 * Return the rest of added value (int) for the next addon addition.
 * @param {string} status : "free" | "discount" | "full"
 * @param {int} addedValue : positive integer only
 * @param {string} nameKey : used as needle to find the specific addon in all subscription addons
 * @param {array} addons
 */
const addAddonQuantity = ({ status, addedValue, nameKey, addons }) => {
    let rest = addedValue;
    const incomingAddon = addons.find(
        (addon) => addon.nameKey === nameKey && addon.status === status,
    );
    if (!incomingAddon) {
        return rest;
    }
    //if addon was previously subtracted, then add the rest to the updatedQuantity
    if (incomingAddon.updatedQuantity && incomingAddon.updatedQuantity < 0) {
        const currentUpdatedQuantity = incomingAddon.updatedQuantity;
        if (rest + currentUpdatedQuantity > 0) {
            incomingAddon.quantity += Math.abs(currentUpdatedQuantity);
            incomingAddon.updatedQuantity = 0;
            rest = rest + currentUpdatedQuantity;
        } else {
            incomingAddon.quantity += rest;
            incomingAddon.updatedQuantity = incomingAddon.updatedQuantity + rest;
            rest = 0;
        }
    } else if (status === 'full') {
        incomingAddon.quantity += rest;
        incomingAddon.updatedQuantity += rest;
        rest = 0;
    }
    return rest;
};

/**
 * Do the subtraction of addons on all addons sharing the same nameKey (all_included | invoicing_management | prospecting_sale )
 * Priority is only the extra added addons (updatedQuantity) aka type = 'full', then when type = 'free', then when type = 'discount',
 * finally when type = 'full' again.
 * @param {array} addons : list of subscription addons
 * @param addon
 * @param {number} addedValue : the actual value in numberInput component. Always a positive integer.
 */
const subtractSubscriptionAddons = ({ addons, addon, addedValue }) => {
    const nameKey = addon.nameKey;
    let rest;

    const incomingAddon = addons.find(
        (addon) => addon.nameKey === nameKey && addon.status === 'full',
    );
    //Only subtract full addon with min = quantity - updated quantity
    if (incomingAddon?.updatedQuantity > 0) {
        incomingAddon.quantity =
            addedValue + incomingAddon.updatedQuantity < 0
                ? incomingAddon.quantity - incomingAddon.updatedQuantity
                : incomingAddon.quantity + addedValue;
        rest =
            addedValue + incomingAddon.updatedQuantity < 0
                ? addedValue + incomingAddon.updatedQuantity
                : 0;
        incomingAddon.updatedQuantity =
            addedValue + incomingAddon.updatedQuantity < 0
                ? 0
                : incomingAddon.updatedQuantity + addedValue;
    } else {
        rest = addedValue;
    }
    //Only subtract free addon with min = 0
    rest = subtractFreeDiscountAddon('free', rest, nameKey, addons);
    //Only subtract discount addon with min = 0
    if (rest) {
        rest = subtractFreeDiscountAddon('discount', rest, nameKey, addons);
    }
    addon.quantity += rest;
    addon.updatedQuantity += rest;
};

/**
 * Subtract addon, for free or discount only, min value = 0;
 * Return the rest of subtracted value (int) for the next addon subtraction.
 * @param {string} status : "free" | "discount"
 * @param {int} addedValue : negative integer only
 * @param {string} nameKey : used as needle to find the specific addon in all subscription addons
 * @param {array} addons : all subscription addons
 */
const subtractFreeDiscountAddon = (status, addedValue, nameKey, addons) => {
    let rest = addedValue;
    const incomingAddon = addons.find(
        (addon) => addon.nameKey === nameKey && addon.status === status,
    );

    if (incomingAddon?.quantity > 0) {
        rest = addedValue + incomingAddon.quantity < 0 ? addedValue + incomingAddon.quantity : 0;
        incomingAddon.quantity +=
            addedValue + incomingAddon.quantity < 0 ? incomingAddon.quantity * -1 : addedValue;
        incomingAddon.updatedQuantity += rest < 0 ? addedValue - rest : addedValue;
    }

    return rest;
};
export { addAddonQuantity, subtractSubscriptionAddons };
